export default __webpack_public_path__ + "static/media/IMG-20241210-WA0014.f2d39f36.jpg";